module.exports = __webpack_public_path__ + "media/images/homepage/playbutton-960f34f0bb63ee9df717b332e90133b8.png";